import React, { createContext } from 'react';
import createActions from './createActionsAndState';

const { Provider, Consumer } = createContext();

const createConsumer = contextToProps => Component => props => (
  <Consumer>
    {context => <Component {...(contextToProps(context, props) || {})} {...props} />}
  </Consumer>
);

const createStore = (store) => {
  const actionsAndState = createActions(store);
  return { ...actionsAndState };
};

export { Provider, createConsumer, createStore };
